import { aadAppPlatformType, dynamicsAppPlatformType, lobAppPlatformType, m365AppPlatformType, } from './constants';
var genericLoggingPlatformTypes = [
    m365AppPlatformType,
    dynamicsAppPlatformType,
    aadAppPlatformType,
    lobAppPlatformType,
];
export function getSanitizedAppId(id, platformType) {
    if (platformType && genericLoggingPlatformTypes.includes(platformType)) {
        // For privacy reasons, use the generic platform type as the id for MOS, Dynamics, AAD, and LOB apps
        return platformType;
    }
    return id;
}
//# sourceMappingURL=logUtils.js.map